const PROBE_ORIGIN = "https://return-path.invalid";

/**
 * A deep link carried across a redirect as `?returnTo=` (path + search).
 * Only same-origin relative paths pass. Resolving against a probe origin
 * rejects every shape a browser would read as another host — `//evil.com`,
 * `/\evil.com`, and tab/newline-split variants the URL parser strips.
 */
export function isSafeReturnPath(value: unknown): value is string {
  if (typeof value !== "string") return false;
  if (!value.startsWith("/") || value.startsWith("//")) return false;
  try {
    return new URL(value, PROBE_ORIGIN).origin === PROBE_ORIGIN;
  } catch {
    return false;
  }
}

export function parseReturnPathSearch(search: Record<string, unknown>): {
  returnTo?: string;
} {
  return isSafeReturnPath(search.returnTo) ? { returnTo: search.returnTo } : {};
}
